
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-livevideo-control\">\n    <div\n        class=\"c-livevideo-control__button c-livevideo-control__button--play\"\n    ></div>\n    <div class=\"c-livevideo-control__state\">\n        ")
    ;  if(isLive === '0'){ 
    ; __append(" ")
    ;  }else if(isLive === '1'){ 
    ; __append(" 正在直播 ")
    ; 
        }else{ 
    ; __append(" 直播已结束 ")
    ;  } 
    ; __append("\n    </div>\n    <div\n        class=\"c-livevideo-control__zoom c-livevideo-control__zoom--zoomin\"\n    ></div>\n</div>\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/liveControl/main.ejs
// module id = 457
// module chunks = 0